<template>
  <div class=" px-4 justify-center max-w-[1000px] max-h-[600px] ">
    <div class="justify-center flex mb-4  ">
      <span class="text-sm w-full" v-html="value.message"></span>
    </div>


    <div >
      <h1 class="p-1 text-lg">Auf welchen Seiten möchtest du das Template ändern</h1>
    </div>
    <div class="overflow-auto flex">
      <div  v-for="page in value.pages" :key="page.pageId" class="flex flex-wrap ">
        <div class="bg-trader-gray p-4 m-2 flex">
          <span class="mr-2">{{ page.pagePosition }}</span>
          <input type="checkbox" :checked="pageIds.includes(page.pageId)" @click="getPageIds(page.pageId)" >
        </div>
      </div>
    </div>

    <div v-if="value.showMarket">
      <h1 class="p-1 text-lg">Auf welchen Märkten möchtest du das Template ändern</h1>
    </div>
    <div class="grid-cols-12 grid  overflow-auto" v-if="value.showMarket">
      <div v-for="market in markets" :key="market.marketId" class=" ">
        <div class="bg-trader-gray p-4 m-2 flex">
          <span class="mr-2">{{ market.name }}</span>
          <input type="checkbox" @click="getMarketIds(market.marketId)"  :checked="marketIds.includes(market.marketId)"  >
        </div>
      </div>
    </div>
    <div class="flex mb-2">
      <button class="p-2 bg-trader-gray mr-2" @click="getAllPages">Alle Seiten auswählen</button>
      <button class="p-2 bg-trader-gray mr-2" @click="getAllMarkets">Alle Märkte auswählen</button>
    </div>

    <div class="w-full flex gap-2 mb-2">
      <button class="bg-trader-red text-trader-dark-red w-1/2 rounded p-2 mt-2" @click="deleteTrue"
              data-ui="delete-yes">Ja
      </button>
      <button class="bg-trader-green w-1/2 rounded p-2 mt-2" @click="deleteFalse" data-ui="delete-no">Nein</button>
    </div>
  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus.js";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      markets: [],
      marketIds: [],
      pageIds: []
    }
  },
  mounted() {
    
    this.getMarkets();
  },
  methods: {
    getAllPages() {
      this.pageIds = this.value.pages.map(page => page.pageId);
    },
    getAllMarkets() {
      this.marketIds = this.markets.map(market => market.marketId);
    },
    getMarketIds(marketId) {
      if (this.marketIds.includes(marketId)) {
        this.marketIds = this.marketIds.filter(id => id !== marketId);
      } else {
        this.marketIds.push(marketId);
      }
    },
    getPageIds(pageId) {
      if (this.pageIds.includes(pageId)) {
        this.pageIds = this.pageIds.filter(id => id !== pageId);
      } else {
        this.pageIds.push(pageId);
      }
    },
    async getMarkets() {
      const query = gql`
        query getMarkets {
          getMarkets  {
            marketId
            name
            description
            isActive
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({query});
        this.markets = data.getMarkets;
      } catch (error) {
        console.error(error);
      }
    },
    deleteTrue() {
      eventBus.closeModal();
      this.value.getMarketIds(this.marketIds, this.pageIds);

      try {
        if (this.value.onAccept) {
          this.value.onAccept();
        }
      } catch (e) {
      }

    },
    deleteFalse() {
      eventBus.closeModal();

      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
      }


    }
  },


}


</script>

